import { lazy } from "react";

const lazyRetry = (componentImport) =>
  lazy(() =>
    componentImport().catch((error) => {
      console.error("Chunk load failed: ", error);
      const hasReloaded = window.localStorage.getItem("chunk-error-reloaded");
      if (!hasReloaded) {
        window.localStorage.setItem("chunk-error-reloaded", "true");
        // Use a cache-busting query parameter to force fetching the latest index.html fix
        const currentUrl = window.location.href;
        const cacheBuster = `t=${new Date().getTime()}`;
        const separator = currentUrl.includes("?") ? "&" : "?";
        window.location.href = `${currentUrl}${separator}${cacheBuster}`;
      } else {
        throw error;
      }
    })
  );

export default lazyRetry;
